module.exports = __webpack_public_path__ + "img/big.f0e8c8ee.jpg";